import FESCODDLOGO from "../images/discologos/fesco.jpg";
import GEPCODDLOGO from "../images/discologos/gepco.jpg";
import HAZECODDLOGO from "../images/discologos/hazeco_logo-removebg-preview.png";
import HESCODDLOGO from "../images/discologos/hesco logo.png";
import IESCODDLOGO from "../images/discologos/iesco logo.png";
import LESCODDLOGO from "../images/discologos/lesco.jpg";
import MEPCODDLOGO from "../images/discologos/mepco1.jpg";
import PESCODDLOGO from "../images/discologos/pesco1.jpg";
import QESCODDLOGO from "../images/discologos/qesco.png";
import SEPCODDLOGO from "../images/discologos/sepco.jpg";
import TESCODDLOGO from "../images/discologos/tesco.jpg";

/** Distribution companies shown in code-10 admin company dropdown */
export const DISCO_COMPANIES = [
  { code: "11", name: "LESCO", logo: LESCODDLOGO },
  { code: "12", name: "GEPCO", logo: GEPCODDLOGO },
  { code: "13", name: "FESCO", logo: FESCODDLOGO },
  { code: "14", name: "IESCO", logo: IESCODDLOGO },
  { code: "15", name: "MEPCO", logo: MEPCODDLOGO },
  { code: "26", name: "PESCO", logo: PESCODDLOGO },
  { code: "27", name: "HAZECO", logo: HAZECODDLOGO },
  { code: "37", name: "HESCO", logo: HESCODDLOGO },
  { code: "38", name: "SEPCO", logo: SEPCODDLOGO },
  { code: "48", name: "QESCO", logo: QESCODDLOGO },
  { code: "59", name: "TESCO", logo: TESCODDLOGO },
];
